import axios from '../utils/axios'


export const getProductsPlan = async () => {
    try {
        const result = await axios.get(`/api/plans`)
        return result?.data?.data || []
    } catch (err) {
        return []
    }
}

const subscriptionPrefix = '/api/subscriptions'

export const getPaymentIntent = () => {
    return axios.post(`${subscriptionPrefix}/payment-intent`)
}

export const validateCoupon = (coupon) => {
    return axios.post(`${subscriptionPrefix}/validate-coupon/${coupon}`)
}

export const subscribe = (price_id, payment_method, coupon_code, utm_params = {}, referral = null) => {
    return axios.post(`${subscriptionPrefix}/subscribe`, {
        price_id: price_id,
        payment_method: payment_method,
        coupon_code: coupon_code,
        utm_params,
        referral,
    })
}

export const confirmPayment = (payment_intent) => {
    return axios.post(`${subscriptionPrefix}/confirm-payment`, {payment_intent: payment_intent})
}

export const cancel = async () => {
    return axios.post(`${subscriptionPrefix}/cancel`)
}

export const resumeSubscription = async (price_id) => {
    return axios.post(`${subscriptionPrefix}/resume`, {price_id: price_id})
}
